import { gql } from '@apollo/client'

export const PRODUCTS_LIST = gql`
  query GetNewReleases($input: ProductInput) {
    getNewReleases(input: $input) {
      products {
        id
        name
        campaign_id
        parent_id
        configuration
        created_at
        active
        gpid
        gps_status
        publish_date
        updated_at
        properties {
          initial_release_date
        }
        campaign {
          id
          name
          owner_id
          unit_id
          label_id
          artist {
            id
            name
            gps_status
            gcdm_info {
              company
              country
              genre
            }
          }
          user {
            email
            first_name
            last_name
          }
        }
      }
      total
    }
  }
`
